import React from 'react';
import uniqBy from 'lodash/uniqBy';
import {List} from 'immutable';
import RadioSelect from 'components/pure/utils/form/RadioSelect';
import {RadioButton} from 'material-ui/RadioButton';
import RangeField from 'components/pure/utils/form/RangeField';
import AccountSearch from 'components/crm/home/AccountSearch';
import OpportunitySearch from 'components/crm/home/OpportunitySearch';
import ContactSearch from 'components/crm/home/ContactSearch';
import CrmAccountActions from 'actions/crm-opp-ui/CrmAccountActions';
import CrmOpportunityActions from 'actions/crm-opp-ui/CrmOpportunityActions';
import CrmContactActions from 'actions/crm-opp-ui/CrmContactActions';
import {CallConditionType} from 'records/CallTrigger';
import './CrmSelectionStyles.styl';

const {HAVING_OPPORTUNITY_AMOUNT, WITH_CONTACT, TO_ACCOUNT, FOR_OPPORTUNITY, AT_OPPORTUNITY_STAGE} =
  CallConditionType;

export default class CrmSelection extends React.Component {
  constructor(props) {
    super(props);

    this.amountRangeChange = this.amountRangeChange.bind(this);
    this.accountClick = this.accountClick.bind(this);
    this.opportunityClick = this.opportunityClick.bind(this);
    this.contactClick = this.contactClick.bind(this);
  }

  amountRangeChange(value) {
    this.props.selectedValueChanged(value);
  }

  accountClick(account) {
    CrmAccountActions.fetchAccount(account.id);
    this.props.selectedValueChanged(account.id);
  }

  opportunityClick(opportunity) {
    CrmOpportunityActions.fetchOpportunity(opportunity.id);
    this.props.selectedValueChanged(opportunity.id);
  }

  contactClick(contact) {
    CrmContactActions.fetchContact(contact.id);
    this.props.selectedValueChanged(contact.id);
  }

  // de-dup accounts based on their name
  // contacts "name" property includes their email
  filterByName(values) {
    if (!values || values.size === 0 || values.length === 0) {
      return values;
    }
    const uniqueItems = uniqBy(values.toArray(), a => a.name);
    return new List(uniqueItems);
  }

  filterByType(values) {
    if (!values || values.size === 0 || values.length === 0) {
      return values;
    }
    return values.filter(o => o.crmEngagementType !== 'direct');
  }

  render() {
    const {context, stageOptions} = this.props;
    const selectedContextType = context ? context.type : null;
    const selectedValue = context ? context.getValue() : null;
    const {start, end} = (selectedContextType === HAVING_OPPORTUNITY_AMOUNT && selectedValue) || {
      start: 0,
      end: 0,
    };

    return (
      <div className="crm-context-select">
        <ul>
          <li>
            <RadioSelect
              label="Opportunity at Stage"
              checked={selectedContextType === AT_OPPORTUNITY_STAGE}
              options={stageOptions}
              value={selectedValue}
              valueChanged={this.props.selectedValueChanged}
              radioClick={() => this.props.selectedContextTypeChanged(AT_OPPORTUNITY_STAGE)}
            />
          </li>
          <li>
            <div
              className="radio-select-field"
              onClick={() => this.props.selectedContextTypeChanged(FOR_OPPORTUNITY)}>
              <div className="radio-wrapper">
                <RadioButton
                  label="Opportunity / Case"
                  checked={selectedContextType === FOR_OPPORTUNITY}
                  onClick={() => this.props.selectedContextTypeChanged(FOR_OPPORTUNITY)}
                />
              </div>
              <OpportunitySearch
                selectEntity={this.opportunityClick}
                placeholder={'Search Opportunities'}
                className="triggers-page"
                searchDisabled={selectedContextType !== FOR_OPPORTUNITY}
                autoFocus={selectedContextType === FOR_OPPORTUNITY}
                filterResults={this.filterByType}
              />
            </div>
          </li>
          <li>
            <div
              className="radio-select-field"
              onClick={() => this.props.selectedContextTypeChanged(TO_ACCOUNT)}>
              <div className="radio-wrapper">
                <RadioButton
                  label="Account"
                  checked={selectedContextType === TO_ACCOUNT}
                  onClick={() => this.props.selectedContextTypeChanged(TO_ACCOUNT)}
                />
              </div>
              <AccountSearch
                selectEntity={this.accountClick}
                placeholder={'Search Accounts'}
                className="triggers-page"
                searchDisabled={selectedContextType !== TO_ACCOUNT}
                autoFocus={selectedContextType === TO_ACCOUNT}
              />
            </div>
          </li>
          <li>
            <div
              className="radio-select-field"
              onClick={() => this.props.selectedContextTypeChanged(WITH_CONTACT)}>
              <div className="radio-wrapper">
                <RadioButton
                  label="Lead / Contact"
                  checked={selectedContextType === WITH_CONTACT}
                  onClick={() => this.props.selectedContextTypeChanged(WITH_CONTACT)}
                />
              </div>
              <ContactSearch
                selectEntity={this.contactClick}
                placeholder={'Search Contacts'}
                className="triggers-page"
                searchDisabled={selectedContextType !== WITH_CONTACT}
                autoFocus={selectedContextType === WITH_CONTACT}
                filterResults={this.filterByName}
              />
            </div>
          </li>
          <li>
            <div
              className="radio-select-field"
              onClick={() => this.props.selectedContextTypeChanged(HAVING_OPPORTUNITY_AMOUNT)}>
              <div className="radio-wrapper">
                <RadioButton
                  label="Opportunity with amount"
                  checked={selectedContextType === HAVING_OPPORTUNITY_AMOUNT}
                  onClick={() => this.props.selectedContextTypeChanged(HAVING_OPPORTUNITY_AMOUNT)}
                />
              </div>
              <div className="range-inputs">
                <RangeField
                  autoFocus={selectedContextType === HAVING_OPPORTUNITY_AMOUNT}
                  prefix="$"
                  start={start}
                  end={end}
                  onValueChange={this.amountRangeChange}
                  formatLabel={value => ''}
                  showInputRange={false}
                  suffix=""
                  range={{start: 0, end: Number.MAX_SAFE_INTEGER}}
                  disabled={selectedContextType !== HAVING_OPPORTUNITY_AMOUNT}
                />
              </div>
            </div>
          </li>
        </ul>
      </div>
    );
  }
}
